<template>

  <div 
    class="d-flex align-items-center justify-content-center">

    <div 
      class="spinner-border text-info m-5" role="status" 
      v-bind:style="{width: width , height: height}">
      
      <span 
        class="sr-only">
        
        Loading...

      </span>

    </div>

  </div>

</template>

<script>
  export default 
  {
    props:{
      width:{
        type: String
      },
      height:{
        type: String
      }
    },
    data () 
    {
      return {}
    }
  }
</script>
